import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClipboard2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clipboard-2, copy, list"><path fillRule="evenodd" clipRule="evenodd" d="M16.5675 4H17.25C19.3211 4 21 5.67893 21 7.75V18.25C21 20.3211 19.3211 22 17.25 22H6.75C4.67893 22 3 20.3211 3 18.25V7.75C3 5.67893 4.67893 4 6.75 4H7.43252C8.06127 2.81055 9.31098 2 10.75 2H13.25C14.689 2 15.9387 2.81055 16.5675 4ZM15.5 5.75C15.5 4.50736 14.4926 3.5 13.25 3.5H10.75C9.50736 3.5 8.5 4.50736 8.5 5.75V6.25C8.5 6.38807 8.61193 6.5 8.75 6.5H15.25C15.3881 6.5 15.5 6.38807 15.5 6.25V5.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconClipboard2;
